module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/sp-title-ca2a9318c0623ab533febbc055af9753.png";